import { Chip } from "@mui/material";
import React from "react";
import { statusSeverity } from "../utils/statusColors";

const ActiveChip = ({ status, disabled = false }) => {
    const chipStatusColor = statusSeverity("active", status);

    return (
        <>
            <Chip
                color={chipStatusColor}
                size="small"
                variant="outlined"
                label={status}
                disabled={disabled}
            />
        </>
    );
};

export default ActiveChip;